var DataConsentService = /** @class */ (function () {
    function DataConsentService() {
    }
    DataConsentService.getInstance = function () {
        if (!DataConsentService.instance) {
            DataConsentService.instance = new DataConsentService();
        }
        return DataConsentService.instance;
    };
    DataConsentService.prototype.getDataConsentValue = function (form, selector) {
        var radioBtn = form.querySelector("input[name=\"" + selector + "\"]:checked");
        return radioBtn && radioBtn.checked ? radioBtn.value.toUpperCase() : null;
    };
    return DataConsentService;
}());
export { DataConsentService };



//////////////////
// WEBPACK FOOTER
// ./services/data-consent.service.ts
// module id = 65
// module chunks = 0